// extracted by mini-css-extract-plugin
export default {"wheelSpinModal":"WheelSpinModal_wheelSpinModal__sipmC","body":"WheelSpinModal_body__C5Ur2"};